import { Moment } from "moment";
import { HttpClient, HttpRequest } from "../../../views/common/HttpClient";
import { Balance } from "../../../site-timeclock/models/balance";
import { TerminalLoginResponse, StampCostDivision, Signature, StampRequest } from "../models";
import { toJsonMoments } from "tp/views/common/momentParsing";

// "http://ci_master.timeplan.local/api/v1"
let client: HttpClient = null;

export interface OfflineStampRequest {
    personRef?: number;
    signature?: string;
    personCode?: string;
    direction: string;
    stampTime: Moment;
}

export interface SelfRegistrationRequest {
    personNo: string;
    mobile?: string;
    phone: string;
    costDivisionRef: number;
}

export interface RefreshSessionResponse {
    signatures: Signature[];
    serverVersion: string;
}

export const initialize = (url: string): HttpClient =>
    client = new HttpClient(url, toJsonMoments);

export const ping = (deviceSupport: { key: string; value: string }): Promise<void> =>
    client.fetch(HttpRequest.postJson("/timeclock/ping", deviceSupport));

export const terminalLogin = (terminalGuid: string): Promise<TerminalLoginResponse> =>
    client.fetch(HttpRequest.postJson("/security/terminallogin", { terminalGuid }));

export const refreshSession = (newerThan?: Moment): Promise<RefreshSessionResponse> => {
    const optionalArgs = (newerThan ? `&newerThan=${newerThan.toISOString()}` : "");

    return client.fetch(HttpRequest.get("/timeclock/refreshsession?devices=1&devices=2" + optionalArgs));
};

export const enroll = (enrollmentRequest: Signature): Promise<void> =>
    client.fetch(HttpRequest.postJson("/timeclock/enroll", enrollmentRequest));

export const stamp = (request: StampRequest): Promise<void> =>
    client.fetch(HttpRequest.postJson("/timeclock/stamp", request));

export const balance = (personRef: number): Promise<Balance[]> =>
    client.fetch(HttpRequest.get("/timeclock/balance/" + personRef));

export const uploadOfflineStamps = (offlineStamps: OfflineStampRequest[]): Promise<void> =>
    client.fetch(HttpRequest.postJson("/timeclock/offlinestamps", { offlineStamps }));

export const selfRegister = (request: SelfRegistrationRequest): Promise<{ existingPerson: unknown, emplNo: string }> =>
    client.fetch(HttpRequest.postJson("/timeclock/selfregister", request));

export const selfRegisterCostDivisions = (): Promise<StampCostDivision[]> =>
    client.fetch(HttpRequest.get("/timeclock/selfregister/costdivisions"));
